export function full_screen_banner_new_style() {
  return {
    //翻页背景
    banner_btn_color: {
      radio_val: 'default',
      default: {
        color: "rgba(133,133,133, 1)",
        seColor: "rgba(133,133,133, 1)",
      },
      custom: {
        color: "rgba(133,133,133, 1)",
        seColor: "rgba(133,133,133, 1)",
      }
    },

    //页码颜色
    num_color: {
      radio_val: 'default',
      default: {
        color: "rgba(255, 255, 255, 1)",
      },
      custom: {
        color: "rgba(255, 255, 255, 1)",
      }
    },

  }
}

export function create_data() {
  return {
    //滚动个数
    slides_group: {
      radio_val: 'default',
      default: {
        value: '1',
      },
      custom: {
        value: '1',
      }
    },

    //首尾相连
    swiper_loop: 'false',

    //轮播参数
    banner_set: {
      radio_val: 'default',
      default: {
        speed: 0.5,//切换速度
        delay: 2,//展示时间
      },
      custom: {
        speed: 3,//切换速度
        delay: 5,//展示时间
      }
    },


  }
}

export function basic_download_new_style() {
  return {
    download_form: {
      radio_val: 'default',
      default: {
        value: ''
      },
      custom: {
        value: ''
      }
    }
  }
}

export function basic_navbar_new_style() {
  return {
    bilingualSet: {
      radio_val: 'default',
      default: {
        type: 0
      },
      custom: {
        type: 0
      }
    },
    navTextAlign: 'center'
  }
}

export function basic_nleavemessage_new_style() {
  return {
    form_item_bg: {
      radio_val: 'default',
      default: {
        color: 'rgba(204, 204, 204, 0.15)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(204, 204, 204, 0.15)',
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        color: 'rgba(204, 204, 204, 0.15)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(204, 204, 204, 0.15)',
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
    form_item_border: {
      radio_val: 'default',
      default: {
        borderWidth: 1,
        borderColor: 'rgba(224, 224, 224, 1)',
        seBorderColor: 'rgba(224, 224, 224, 1)'
      },
      custom: {
        borderWidth: 1,
        borderColor: 'rgba(224, 224, 224, 1)',
        seBorderColor: 'rgba(224, 224, 224, 1)'
      }
    }
  }
}

// 组合阴影
export function box_shadow_style_add() {
  return {
    boxShadow: { //  rgba(0, 0, 0, 0.1) 0 0 15px;
      radio_val: 'default',
      default: {
        direction: 'outset',
        x: 0,
        y: 0,
        spread: 0,
        blur: 15,
        color: 'rgba(0,0,0,0)',
        seColor: 'rgba(0,0,0,0.1)',
      },
      custom: {
        direction: 'outset',
        x: 0,
        y: 0,
        spread: 0,
        blur: 4,
        color: 'rgba(0,0,0,0.3)',
        seColor: 'rgba(0,0,0,0.5)',
      }
    }
  }
}

export function basic_classification_new_style() {
  return {
    level_1_is_move: false,
    level_2_is_move: false,
    level_3_is_move: false,
    navbarByIds: '',
    navbarByThemeName: '',
    textAlign: 'left'
  }
}

export function getBackgroundData() {
  return {
    background: {
      radio_val: 'default',
      default: {
        type: 'color', // 背景设置-类型
        img: '', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'cover',
        background_repeat: 'no-repeat',
        background_position: 'center center', //图片位置
        seColor:'rgba(255, 255, 255,1)' // 添加悬浮颜色
      },
      custom: {
        type: 'color', // 背景设置-类型
        img: '', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'cover',
        background_repeat: 'no-repeat',
        background_position: 'center center', //图片位置
        seColor:'rgba(255, 255, 255,1)' // 添加悬浮颜色
      }
    },
  }
}

export function getSwiperSettingData() {
  return {
    //滚动个数
    slides_group: {
      radio_val: 'default',
      default: {
        value: '1',
      },
      custom: {
        value: '1',
      }
    },

    //首尾相连
    swiper_loop: 'false',

    //轮播参数
    banner_set: {
      radio_val: 'default',
      default: {
        speed: 0.5,//切换速度
        delay: 2,//展示时间
      },
      custom: {
        speed: 3,//切换速度
        delay: 5,//展示时间
      }
    },
  }
}

// 产品展示 这这边的 添加 文字标题设置
export function font_set_add() {
  return {
    radio_val: 'custom',
    custom: {
      fontSize: 16,
      fsWeight: 'normal',
      fsItalics: 'normal',
      fontStyle: '',
      fontUnderline: 'none',
      fontFamily: 'Arial',
      fontColor: 'rgba(51, 51, 51,1)',
      // lineHeight: '20',
      /* textAlign: 'left',
      background: 'rgba(252, 255, 255,1)',
      pattern: 'pure_color',
      linear_gradient: {
        start_color: "rgba(0,0,0,1)",
        end_color: "rgba(0, 0, 0,1)",
        start_pointer: 0,
        end_pointer: 100,
        deg: 90
      } */
    }
  }
}

// 字体
export function fontSet() {
  return {
    radio_val: 'default',
      default: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 18,
        fsWeight: 'normal',
        fontColor: 'rgba(51,51,51,1)',
        selectColor: 'rgba(156,40,177,1)',
        fontFamily: 'Arial',
        textAlign:'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 18,
        fsWeight: 'normal',
        fontColor: 'rgba(51,51,51,1)',
        selectColor: 'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        textAlign:'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
  }
}
export function basic_product_display_new_style() {
  return {
    button_text:{
      isHidden:true,
      value: 'view details',
      styleType: 'type_0',
      buttonStyle: {
        fontColor: '',
        fontSeColor: '',
        backgroundColor: '',
        backgroundSeColor: '',
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: "rgba(255, 255, 255,1)",
        borderSeColor: "rgba(0, 0, 0,1)",
        borderRadius: 4
      }
    }
  }
}

export function basic_language_new_style() {
  return {
    background:{
      radio_val: 'default',
      default: {
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(255, 255, 255,1)', // 背景设置-选中颜色
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(255, 255, 255,1)', // 背景设置-选中颜色
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        }
      }
    }
  }
}


export function getCommonStyle() {
  return {
    borderRadius: {
      radio_val: 'default',
      default: { value: 0 },
      custom: { value: 4 }
    }
  }
}








// WEBPACK FOOTER //
// ./src/base/widgets_data_compatible.js